const maintenanceRequests = {
  getMaintenanceMessageRequest: () => ({
    url: `api/maintenance/message`,
    method: 'get',
  }),
}

export default maintenanceRequests
